// @ts-nocheck

/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { FunctionComponent, useEffect, useRef, useState } from 'react'
import {
  PauseIcon,
  PlayIcon,
  TikTokWhiteIcon,
  CurlLinkIcon,
} from 'Stories/Icon/Icon.stories'

import { AudioProps } from './PlayerProps'

import {
  Background,
  Button,
  Container,
  Content,
  CoverWrapper,
  Duration,
  Slider,
  Track,
  ArtistName,
  TrackName,
  TrackWrapper,
  TikTokWhiteIconWrapper,
  CurlLinkIconWrapper,
} from './styles'

const TRACK_UPDATE_DELAY = 1000

const parseTime = (time: number | undefined) => {
  const minutes = Math.floor(time / 60).toFixed(0)
  const seconds = Number((time % 60).toFixed(0))

  return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`
}

export const Player: FunctionComponent<AudioProps> = ({
  url,
  cover,
  authorName,
  trackName,
}) => {
  const audio = useRef<HTMLAudioElement | null>(null)
  const duration = audio?.current?.duration

  const [playing, setPlaying] = useState(false)
  const [currentTime, setCurrentTime] = useState(0)

  useEffect(() => {
    if (playing) {
      const timer = setInterval(() => {
        setCurrentTime(audio.current?.currentTime)
      }, TRACK_UPDATE_DELAY)

      return () => {
        clearInterval(timer)
      }
    }
  }, [playing])

  const handleTimeChange = (event: React.MouseEvent<HTMLDivElement>) => {
    if (audio?.current) {
      const { left, width } = event.currentTarget.getBoundingClientRect()
      const currentX = event.pageX - left
      audio.current.currentTime = (currentX / width) * duration
      setCurrentTime(audio.current.currentTime)
    }
  }

  const playTrack = () => {
    audio.current?.play()
    setPlaying(true)
  }

  const pauseTrack = () => {
    audio.current?.pause()
    setPlaying(false)
  }

  const handleTrackEnd = () => {
    setPlaying(false)
  }

  const toogle = () => (playing ? pauseTrack() : playTrack())

  const trackWidth = `${(currentTime / duration) * 100}%`
  const time = parseTime(currentTime)

  return (
    <>
      <audio src={url} ref={audio} onEnded={handleTrackEnd} />
      <Background>
        <Container>
          <CoverWrapper>
            <img src={cover} alt="Track cover" />
            <Button onClick={toogle}>
              {playing ? <PauseIcon /> : <PlayIcon />}
            </Button>
          </CoverWrapper>
          <Content>
            <TrackName>{trackName}</TrackName>
            <ArtistName>{authorName}</ArtistName>
            <TrackWrapper onClick={handleTimeChange}>
              <Track style={{ width: trackWidth }}>
                <Slider />
              </Track>
            </TrackWrapper>

            <TikTokWhiteIconWrapper>
              <TikTokWhiteIcon />
            </TikTokWhiteIconWrapper>

            <Duration>{time}</Duration>
            <CurlLinkIconWrapper>
              <CurlLinkIcon />
            </CurlLinkIconWrapper>
          </Content>
        </Container>
      </Background>
    </>
  )
}
